import { useMemo, useState } from 'react';
import { usePermissions } from '../../../../../hooks/usePermissions';
import type { EventDatabse, SubjectHistoryFeed } from '../../../../../types';
import { getGoogleCalendarUrl } from '../../../../../utils/googleCalendar';

export type UseEventMenuActionsProps = {
  event: EventDatabse;
};

export function useEventMenuActions(props: UseEventMenuActionsProps) {
  const { isAdmin } = usePermissions();
  const [activeModal, setActiveModal] = useState<'update' | 'delete' | 'move' | null>(null);

  function handleUpdateClick() {
    setActiveModal('update');
  }

  function handleDeleteClick() {
    setActiveModal('delete');
  }

  function handleMoveClick() {
    setActiveModal('move');
  }

  function handleModalClose() {
    setActiveModal(null);
  }

  function handleAddToGoogleCalendar() {
    if (!props.event.date || !props.event.title) return;
    const url = getGoogleCalendarUrl({
      title: props.event.title,
      date: props.event.date,
      end_date: props.event.end_date,
      all_day: props.event.all_day,
      description: props.event.description,
      provider_name: props.event.provider_name,
      contact_name: props.event.contact_name,
    });
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  const historyItem = useMemo(() => {
    return {
      id: props.event.id,
      source: 'event',
      subject_id: props.event.subject_id,
      title: props.event.title,
      date: props.event.date,
      end_date: props.event.end_date,
      all_day: props.event.all_day,
      comment: props.event.description,
      provider_name: props.event.provider_name,
      contact_name: props.event.contact_name,
    } as SubjectHistoryFeed;
  }, [
    props.event.id,
    props.event.subject_id,
    props.event.title,
    props.event.date,
    props.event.end_date,
    props.event.all_day,
    props.event.description,
    props.event.provider_name,
    props.event.contact_name,
  ]);

  return {
    isAdmin,
    activeModal,
    historyItem,
    handleUpdateClick,
    handleDeleteClick,
    handleMoveClick,
    handleModalClose,
    handleAddToGoogleCalendar,
  };
}

export const useEventItemMenu = useEventMenuActions;

